import httpBuildQuery from '../../../httpBuildQuery'

export const DYNAMICALLY_INSTRUMENT_FUNCTION = 'V2/TrackFunction/Track'
export const FETCH_DYNAMICALLY_INSTRUMENTED_FUNCTIONS = 'V2/TrackFunction/FetchAll'
export const TRACK_USER_EVENT = 'V2/TrackFunction/UseFeature'

export const dynamicallyInstrumentFunction = (data: any) => ({
    type: DYNAMICALLY_INSTRUMENT_FUNCTION,
    payload: ({ fetchForApplication }) =>
        fetchForApplication('/track-function', {
            method: 'POST',
            body: httpBuildQuery({ data }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }),
})

export const fetchAllDynamicallyInstrumentedFunctions = () => ({
    type: FETCH_DYNAMICALLY_INSTRUMENTED_FUNCTIONS,
    payload: ({ fetchForApplication }) => fetchForApplication('/fetch-all-tracked-functions'),
})
